import { Box } from "@mui/material";

const AboutUsItem = ({ title, text, icon }) => {
  return (
    <Box
      sx={{
        display: "flex",
        position: "relative",
        gap: "2rem",
        flexDirection: "column",
        // width: "38rem",
        flexBasis: "22rem",
        flexGrow: 1,

        background: "linear-gradient(180deg, var(--background-color0) 0%, var(--background-color1) 100%)",
        padding: "2rem",
        borderRadius: "1rem",
        alignItems: "center"
      }}
    >
      <Box
        component="img"
        src={icon}
        alt="MVP Icon"
        sx={{
          width: "14rem",
          objectFit: "contain",
          borderRadius: "2rem",
        }}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "0.8rem",
          textAlign: "center"
        }}
      >
        <span
          style={{
            fontWeight: 600,
            fontSize: "1.3rem",
          }}
        >
          {title}
        </span>
        <span
          style={{
            fontSize: "1rem",
            textAlign: "center",
          }}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </Box>
    </Box>
  );
};

export default AboutUsItem;
